/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * TEMPERATURE rows carry value/unit/target bounds; PASS_FAIL rows carry failureDetail instead, and on those rows isOutOfRange is the pass/fail verdict (true = failed). UNTARGETED rows recorded a check with no target to judge it against: target bounds are null, isOutOfRange is always false, and value is null unless the check measured something (food temperature does, garden and sleep checks do not). Clients must branch on this before formatting the value column.
 */
export enum MonitoringEntryDtoValueKind {
  TEMPERATURE = "TEMPERATURE",
  PASS_FAIL = "PASS_FAIL",
  UNTARGETED = "UNTARGETED",
}
